import { render, staticRenderFns } from "./OffersCard.vue?vue&type=template&id=c1e732aa&scoped=true&"
import script from "./OffersCard.vue?vue&type=script&lang=js&"
export * from "./OffersCard.vue?vue&type=script&lang=js&"
import style0 from "./OffersCard.vue?vue&type=style&index=0&id=c1e732aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e732aa",
  null
  
)

export default component.exports